import { createContext, useContext } from 'react';
import { initialReferralForm, ReferralFormData } from './ReferralData';
import { initialProData, ProData } from '../../../shared/types';

interface ReferralContextData {
  referral: ReferralFormData;
  updateReferral: (referral: Partial<ReferralFormData>) => void;
  phoneVerificationCountDown: number;
  updatePhoneVerificationCountDown: (countDown: number) => void;
  proInfo: ProData;
  updateProInfo: (proInfo: ProData) => void;
  isProTrackingStatuses: boolean;
  setIsProTrackingStatuses: (isTracking: boolean) => void;
}

const Context = createContext<ReferralContextData>({
  referral: initialReferralForm(),
  updateReferral: () => {
    return;
  },
  phoneVerificationCountDown: 0,
  // eslint-disable-next-line
  updatePhoneVerificationCountDown: (_) => {},
  proInfo: initialProData(),
  // eslint-disable-next-line
  updateProInfo: (_) => {},
  isProTrackingStatuses: false,
  setIsProTrackingStatuses: () => {}
});

function useReferralContext() {
  return useContext(Context);
}

export { Context, useReferralContext };
